var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fa',{staticClass:"mr-2",attrs:{"icon":['far', 'clock']}}),_vm._v("\n    "+_vm._s(_vm.timeString)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }